import { render, staticRenderFns } from "./Administration.vue?vue&type=template&id=48f90ff6&scoped=true"
import script from "./Administration.vue?vue&type=script&lang=js"
export * from "./Administration.vue?vue&type=script&lang=js"
import style0 from "./Administration.vue?vue&type=style&index=0&id=48f90ff6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f90ff6",
  null
  
)

export default component.exports